import { Component, EventEmitter, Inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { SHELF_CONTEXT_MENU_PARAMS, ShelfContextMenuParams } from '../../services/contextmenu.service';
import { CapabilitiesService } from 'src/app/services/capabilities.service';
import { CapabilityType } from 'src/app/models/capability-type';

@Component({
  selector: 'app-shelf-context-menu',
  templateUrl: './shelf-context-menu.component.html',
  styleUrls: ['./shelf-context-menu.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None
})
export class ShelfContextMenuComponent {
  @Input() position: { x: number, y: number } = { x: 0, y: 0 };

  @Output() openDropMenu = new EventEmitter<string>();
  @Output() removeShelf = new EventEmitter<string>();
  @Output() addShelfBelow = new EventEmitter<string>();
  @Output() addShelfAbove = new EventEmitter<string>();
  @Output() copyShelf = new EventEmitter<string>();
  @Output() pasteBelowShelf = new EventEmitter<string>();
  @Output() pasteAboveShelf = new EventEmitter<string>();
  @Output() clearShelf = new EventEmitter<string>();

  expandedMenu: string | null = null;

  constructor(@Inject(SHELF_CONTEXT_MENU_PARAMS) public params: ShelfContextMenuParams,
    private capabilitiesService: CapabilitiesService) {}

  get canEdit(): boolean {
    return this.capabilitiesService.hasCapability(CapabilityType.EDIT_PLANOGRAM);
  }
  
  toggleSubmenu(menu: string, event: Event) {
    event.stopPropagation();
    this.expandedMenu = this.expandedMenu === menu ? null : menu;
  }
}